module.exports = __webpack_public_path__ + "static/infografico-prematuridade-fecdda1fb4a864c92b27f10a70a8d9f6.png";